import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { aaguids } from '@treezor/treezor-sca';

import { IAuthPasskey } from '@/features/dashboard-users/store/support-user.model';

import { getMonth } from '@/utils/tools/DateTools';
import { zeroPad } from '@/utils/tools/MathTools';

export interface IView2FADetailsProps {
  secureKey: IAuthPasskey;
  variant?: 'modal' | 'tooltip';
}

export function View2FADetails({ secureKey, variant = 'tooltip' }: IView2FADetailsProps) {
  const { t } = useTranslation();

  const Key = ({ children }: PropsWithChildren<{}>) => (
    <span className={`typo-body-regular-small !font-light mr-3 ${variant === 'modal' ? 'text-secondary' : ''}`}>
      {children}
    </span>
  );

  const Value = ({ children }: PropsWithChildren<{}>) => <span className={`typo-body-medium-small`}>{children}</span>;

  const createdDate = new Date(secureKey.createdDate);

  return (
    <div className={`p-3 rounded-200 text-nowrap ${variant === 'modal' ? 'p-4 border-2 border-primary' : ''}`}>
      <div className={`typo-subtitle-subtitle3 uppercase mb-3 ${variant === 'modal' ? 'text-tertiary' : ''}`}>
        {t('pages.auth.2fa.view.provider-informations')}
      </div>
      <div>
        <Key>{t('pages.auth.2fa.view.tag')}</Key>
        <Value>{secureKey.secureKeyTag}</Value>
      </div>
      <div>
        <Key>{t('pages.auth.2fa.view.authenticator')}</Key>
        <Value>{aaguids[secureKey.authenticator.aaguid]?.name || secureKey.authenticator.aaguid}</Value>
      </div>
      <div>
        <Key>{t('pages.auth.2fa.view.created-on')}</Key>
        <Value>{`${t(getMonth(createdDate.getMonth())).slice(0, 3)} ${zeroPad(createdDate.getDate(), 2)}, ${createdDate.getFullYear()}`}</Value>
      </div>
    </div>
  );
}
